import { SerializedStyles } from "@emotion/react";
import { Ref, memo } from "react";
import { FormFlowPage, SharedApplicantsSelector } from "src/components";
import { Applicant } from "src/types/Applicant";

import { useMaybeSubmit } from "../hooks";

export interface SharedWithProps {
  onChange: (value: Applicant[]) => void;
  value?: Applicant[];
  sharedItemName: string;
  otherApplicants: Applicant[];
  applicant: Applicant;
  isSubpage?: boolean;

  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
}

const SharedWith = ({
  onNext,
  onBack,
  style,
  focusRef,
  sharedItemName,
  otherApplicants,
  applicant,
  isSubpage = false,
  value,
  onChange,
  ...props
}: SharedWithProps) => {
  const { handleNext, nextDisabled, nextLoading } = useMaybeSubmit({ onNext, shouldSubmit: !isSubpage });

  return (
    <FormFlowPage
      {...props}
      title={`Do you share ${sharedItemName} with any of your fellow applicants?`}
      description="If so, who do you share it with? Adding in this information means the other applicants won't need to add it in for themselves too."
      buttonText={!value?.length ? "Skip" : "Next"}
      onNext={handleNext}
      onBack={onBack}
      nextDisabled={nextDisabled}
      nextLoading={nextLoading}
      style={style}
    >
      <SharedApplicantsSelector
        value={value}
        onChange={onChange}
        applicant={applicant}
        focusRef={focusRef}
        otherApplicants={otherApplicants}
      />
    </FormFlowPage>
  );
};

export default memo(SharedWith);
